module.exports = __webpack_public_path__ + "static/media/dentalOffices.c2dfaecc.jpg";